import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { PostValueResponseModel } from '../../models/core/post-value-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { EntityTypeEnum } from '../../models/enums/entity-type.enum';
import { FavoriteModel } from '../../models/favorite.model';

@Injectable({
    providedIn: 'root'
})
export class FavoritesResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'favourites' }));
    }

    /**
     * Returns list of all favorites.
     */
    getAll(): Observable<ApiResponseModel<FavoriteModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<FavoriteModel[]>>(this.getUrl(''));
    }

    /**
     * Returns list of favorites for the selected entity.
     * @param type Entity type.
     */
    getByType(type: EntityTypeEnum): Observable<ApiResponseModel<FavoriteModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<FavoriteModel[]>>(this.getUrl(type));
    }

    /**
     * Verifies if the current record is already added as a favorite.
     * @param data Item's data.
     */
    exists(data: FavoriteModel): Observable<ApiResponseModel<boolean>> {
        return this._requestService.makeGet<ApiResponseModel<boolean>>(this.getUrl(data.tableName), data.recordId.toString());
    }

    /**
     * Creates a new item.
     * @param data Item's data.
     */
    add(data: FavoriteModel): Observable<ApiResponseModel<PostValueResponseModel>> {
        return this._requestService.makePost<ApiResponseModel<PostValueResponseModel>>(this.getUrl(`${data.tableName}/${data.recordId}`));
    }

    /**
     * Removes the informed item.
     * @param data Data to be removed.
     */
    remove(data: FavoriteModel): Observable<ApiResponseModel<boolean>> {
        return this._requestService.makeDelete<ApiResponseModel<boolean>>(this.getUrl(data.tableName), data.recordId.toString());
    }
}
